import { ApiError } from '../core/api/http'

/**
 * Waarom de inloglink niet werkte. Een antwoord van de server (4xx) = verlopen of al gebruikt;
 * geen antwoord (verbinding, 5xx) zegt niets over de link, dus dan niet "verlopen" beweren.
 */
export const linkNoticeFor = (err: unknown): string =>
  err instanceof ApiError && err.status !== undefined && err.status >= 400 && err.status < 500
    ? 'Deze inloglink is verlopen of al gebruikt. Vraag hieronder een nieuwe aan.'
    : 'We konden je inloglink niet controleren. Controleer je verbinding, of vraag hieronder een nieuwe aan.'

type StartResult<A> = { account: A | null; notice: string | null }

/**
 * Het account bij het openen van de site, met of zonder inloglink uit de mail.
 *
 * Werkt de link niet, dan kijken we nog of ze al ingelogd was (dan geen melding: ze is binnen).
 * Is ze dat niet, dan zegt `notice` waarom; ook als `fetchMe` gewoon `null` geeft (een gast is geen
 * fout). Dat laatste ging eerder mis: de melding hing alleen aan een mislukte `fetchMe`, en kwam dus nooit.
 * Een fout van `fetchMe` zonder inloglink gaat gewoon door naar de aanroeper.
 */
export async function startWithLink<A>(
  token: string | null,
  verify: (token: string) => Promise<A>,
  fetchMe: () => Promise<A | null>,
): Promise<StartResult<A>> {
  if (!token) return { account: await fetchMe(), notice: null }
  try {
    return { account: await verify(token), notice: null }
  } catch (linkError) {
    let account: A | null = null
    try {
      account = await fetchMe()
    } catch {
      account = null
    }
    return { account, notice: account === null ? linkNoticeFor(linkError) : null }
  }
}
